module.exports = __webpack_public_path__ + "img/flow.1dd6cf66.png";